import React from "react";
import Marquee from "react-fast-marquee";
import { CaretUp, CaretDown } from "@phosphor-icons/react";
import { formatPct, formatSignedPct } from "../lib/format";
import { Link } from "react-router-dom";

export default function TrendingStrip({ items = [] }) {
  if (!items.length) return null;
  return (
    <div
      data-testid="trending-strip"
      className="border-b border-white/10 bg-zinc-950/80 overflow-hidden"
    >
      <div className="flex items-center">
        <div className="px-4 py-2 border-r border-white/10 text-[10px] uppercase tracking-[0.25em] font-mono text-edge whitespace-nowrap">
          ◆ Trending
        </div>
        <Marquee gradient={false} speed={28} pauseOnHover className="py-2">
          {items.map((m) => {
            const change = Number(m.oneDayPriceChange || 0);
            const up = change >= 0;
            return (
              <Link
                key={m.id}
                to={`/market/${m.id}`}
                data-testid={`trending-item-${m.id}`}
                className="marquee-item inline-flex items-center gap-3 text-sm font-body text-zinc-300 hover:text-white transition-colors"
              >
                <span className="font-mono text-[11px] text-zinc-500 uppercase">
                  {(m.category || "MKT").slice(0, 10)}
                </span>
                <span className="truncate max-w-[42ch]">{m.question}</span>
                <span className="font-mono text-edge tabular-nums">
                  {formatPct(m.yesPrice, 0)}
                </span>
                <span
                  className={`font-mono text-xs tabular-nums inline-flex items-center gap-0.5 ${
                    up ? "text-profit" : "text-loss"
                  }`}
                >
                  {up ? <CaretUp size={10} weight="fill" /> : <CaretDown size={10} weight="fill" />}
                  {formatSignedPct(change, 1)}
                </span>
              </Link>
            );
          })}
        </Marquee>
      </div>
    </div>
  );
}
